import {api} from '~/mercuryWebBackend/api'
import {useSimpleQuery} from '../../../../mercuryWebBackend/useSimpleQuery'

function useGeolocation() {
  return useSimpleQuery(api.geolocate, {}, {})
}

export function useShowContactSales() {
  const {isPending, isError, data} = useGeolocation()

  if (isPending) {
    return {
      status: 'loading' as const,
    }
  }

  if (isError) {
    return {
      status: 'error' as const,
    }
  }

  return {
    status: 'success' as const,
    data: {
      pageIsVisible: data.isOnboardableCountry && data.country !== 'IN',
    },
  }
}
